import StrikeZoneSectorFormatter from "./resultsFormatters/StrikeZoneSectorFormatter.js";
import BaseballResultsProcessor from "../entities/BaseballResultsProcessor.js";
import GenericResultFormatter from "./resultsFormatters/GenericResultFormatter.js";
import {
    StrikeZoneFrontFormatter, EnumValuesFormatter, DefaultValuesFormatter,
    DateTimeFormatter, PropertyAssuranceFormatter,
} from "./resultFormatters/index.js";
import * as Enums from "../enums/index.js";
import { BatchResultsFormatter } from "./resultsFormatters/index.js";

const playerResultsWithVideoFormatter = function(results, strikeZoneModel, formatCreateDate) {
    const pitchFormatters = [
        new PropertyAssuranceFormatter(
            Enums.ResultData.getDataPath(Enums.PitchData.Classification.key),
            (value) => (typeof(value) !== 'undefined'), Enums.BaseballPitchType.Unidentified.key
        ),
        new DefaultValuesFormatter(Enums.PitchData.StrikeZoneFront)
            .registerReplacement('0; 0; 0', undefined)
            .registerReplacement(';;', undefined),
        new StrikeZoneFrontFormatter(),
        new EnumValuesFormatter([
            Enums.PitchData.Classification, Enums.PitchData.Result, Enums.PitchData.Mechanics,
            Enums.PitchData.SwingHandedness, Enums.PitchData.Handedness, Enums.PitchData.StrikeZonePosition
        ]),
    ];

    const hitFormatters = [
        new EnumValuesFormatter([
            Enums.HitData.SwingHandedness
        ]),
        new DateTimeFormatter([Enums.ResultData.CreateDate.key], '+00:00', null),
    ];

    if (formatCreateDate) {
        pitchFormatters.push(
            new DateTimeFormatter([Enums.ResultData.CreateDate.key], '+00:00', null)
        );
        hitFormatters.push(
            new DateTimeFormatter([Enums.ResultData.CreateDate.key], '+00:00', null)
        );
    }

    const formatters = [
        new BatchResultsFormatter(new PropertyAssuranceFormatter(
            [Enums.ResultData.Data.key], (value) => (typeof(value) === 'object' && value !== null), {}
        )),
        new StrikeZoneSectorFormatter(strikeZoneModel),
        new GenericResultFormatter(pitchFormatters, hitFormatters),
    ];

    // TODO - change to injected object
    return BaseballResultsProcessor.applyFormatting(results, ...formatters);
}

export default playerResultsWithVideoFormatter;